import { Variant } from "../../types/types";
import { encodeColour } from "../string/encodeColour";

/**
 * @deprecated
 * Please don't use this!
 * If you're tempted to use it you're probably doing the wrong thing!
 *
 * Ask Web Arch team for more information.
 *
 * TODO WA-649 - remove this
 */
export function getVariantsMatchingColour(
  variants: Variant[],
  colour: string | undefined | null,
) {
  if (!colour || !variants) return [];

  return variants.filter(
    (variant) =>
      encodeColour(variant.differentiators?.colour) === encodeColour(colour),
  );
}
